<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'users'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/users/detail/_new",
       tableColumns: [
              {
                prop: 'handle',
                label: 'CODE',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'name',
                label: 'NAME',
                minWidth: 180,
                sortable: true,
                key:'NAME'
              },

              {
                prop: 'email',
                label: 'EMAIL',
                minWidth: 180,
                sortable: true,
                key:'EMAIL'
              },
              {
                prop: 'mobile',
                label: ' MOBILE',
                minWidth: 120,
                sortable: true,
                key:'MOBILE'
              }
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            },

        }

  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>